/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Work_0_DescInputs */

const en_svc_retainer_work_0_desc = /** @type {(inputs: Svc_Retainer_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A production community app with real-time updates, monitored and maintained in production.`)
};

const ar_svc_retainer_work_0_desc = /** @type {(inputs: Svc_Retainer_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق مجتمعي في الإنتاج مع تحديثات فورية، مراقب ويُصان في الإنتاج.`)
};

const bn_svc_retainer_work_0_desc = /** @type {(inputs: Svc_Retainer_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিয়েল-টাইম আপডেটসহ প্রোডাকশন কমিউনিটি অ্যাপ, প্রোডাকশনে পর্যবেক্ষিত ও রক্ষণাবেক্ষণ করা।`)
};

const de_svc_retainer_work_0_desc = /** @type {(inputs: Svc_Retainer_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Community-App in Produktion mit Echtzeit-Updates, überwacht und gewartet in Produktion.`)
};

const es_svc_retainer_work_0_desc = /** @type {(inputs: Svc_Retainer_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una app comunitaria en producción con actualizaciones en tiempo real, monitorizada y mantenida en producción.`)
};

const fr_svc_retainer_work_0_desc = /** @type {(inputs: Svc_Retainer_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une app communautaire en production avec mises à jour temps réel, supervisée et maintenue en production.`)
};

const pt_svc_retainer_work_0_desc = /** @type {(inputs: Svc_Retainer_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma app comunitária em produção com atualizações em tempo real, monitorizada e mantida em produção.`)
};

const zh_svc_retainer_work_0_desc = /** @type {(inputs: Svc_Retainer_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产环境的社区应用带实时更新，有监控、有人维护。`)
};

const tr_svc_retainer_work_0_desc = /** @type {(inputs: Svc_Retainer_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerçek zamanlı güncellemeli üretim topluluk uygulaması, üretimde izlenir ve bakımı yapılır.`)
};

const ru_svc_retainer_work_0_desc = /** @type {(inputs: Svc_Retainer_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продовое community-приложение с реалтайм-апдейтами, мониторится и поддерживается в проде.`)
};

const pl_svc_retainer_work_0_desc = /** @type {(inputs: Svc_Retainer_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Społecznościowa apka produkcyjna z aktualizacjami w czasie rzeczywistym, monitorowana i utrzymywana na produkcji.`)
};

/**
* | output |
* | --- |
* | "A production community app with real-time updates, monitored and maintained in production." |
*
* @param {Svc_Retainer_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_retainer_work_0_desc = /** @type {((inputs?: Svc_Retainer_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_retainer_work_0_desc(inputs)
	if (locale === "de") return de_svc_retainer_work_0_desc(inputs)
	if (locale === "es") return es_svc_retainer_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_retainer_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_retainer_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_retainer_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_retainer_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_retainer_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_retainer_work_0_desc(inputs)
	return en_svc_retainer_work_0_desc(inputs)
});